import React, { useState, useCallback } from "react";
import { useSendbirdStateContext, sendBirdSelectors } from "sendbird-uikit";
import {
  containsLink,
  LINK_BLOCKED_MESSAGE,
} from "../../helpers/chatLinkGuard";

const CustomMessageInput = ({ channel }) => {
  const [message, setMessage] = useState("");
  const [linkBlocked, setLinkBlocked] = useState(false);
  const globalStore = useSendbirdStateContext();
  const sdk = globalStore?.stores?.sdkStore?.sdk;
  const sendUserMessage =
    sendBirdSelectors.getOpenChannelSendUserMessage(globalStore);

  // Check if channel is frozen
  const isFrozen = channel?.isFrozen;

  const handleSend = useCallback(() => {
    // Don't send if channel is frozen
    if (isFrozen) return;

    if (message.trim() && channel && sdk && sendUserMessage) {
      // This input is only rendered for non-approved members, who are not
      // allowed to share links in chat (malware-link prevention).
      if (containsLink(message)) {
        setLinkBlocked(true);
        return;
      }

      const params = new sdk.UserMessageParams();
      params.message = message.trim();

      sendUserMessage(channel.url, params)
        .then(() => {
          setMessage("");
        })
        .catch((error) => {
          console.error("Failed to send message:", error);
        });
    }
  }, [message, channel, sdk, sendUserMessage, isFrozen]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  // If channel is frozen, show frozen message
  if (isFrozen) {
    return (
      <div className="sendbird-openchannel-footer">
        <div className="sendbird-message-input-wrapper">
          <div
            className="sendbird-message-input"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              opacity: 0.6,
            }}
          >
            <span className="sendbird-label sendbird-label--body-1 sendbird-label--color-onbackground-3">
              Channel is frozen
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sendbird-openchannel-footer">
      {linkBlocked && (
        <div
          className="sendbird-label sendbird-label--caption-3"
          style={{ color: "#e53935", padding: "0 12px 4px" }}
        >
          {LINK_BLOCKED_MESSAGE}
        </div>
      )}
      <form className="sendbird-message-input-wrapper">
        <div className="sendbird-message-input">
          <textarea
            className="sendbird-message-input--textarea"
            name="sendbird-message-input"
            maxLength={5000}
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              if (linkBlocked) setLinkBlocked(false);
            }}
            onKeyDown={handleKeyDown}
          />
          {!message && (
            <span className="sendbird-message-input--placeholder sendbird-label sendbird-label--body-1 sendbird-label--color-onbackground-3">
              Enter message
            </span>
          )}
          {/* NO .sendbird-message-input--attach button - only approved analysts get file upload */}
          {message && (
            <button
              className="sendbird-message-input--send sendbird-iconbutton"
              type="button"
              onClick={handleSend}
              style={{ height: "32px", width: "32px" }}
            >
              <span className="sendbird-iconbutton__inner">
                <div
                  className="sendbird-icon sendbird-icon-send sendbird-icon-color--primary"
                  role="button"
                  tabIndex="0"
                  style={{
                    width: "20px",
                    minWidth: "20px",
                    height: "20px",
                    minHeight: "20px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 64 64"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <path
                      className="icon-send_svg__fill"
                      d="M59.795 29.43L7.329 2.979C4.691 1.802 1.76 4.153 2.932 6.798l6.925 18.609a2 2 0 001.544 1.275l32.273 5.394L11.4 37.47a1.998 1.998 0 00-1.544 1.275L2.932 57.353c-.879 2.645 1.76 4.997 4.397 3.527l52.466-26.453c2.051-.882 2.051-3.82 0-4.996z"
                      fill="#000"
                      fillRule="evenodd"
                    />
                  </svg>
                </div>
              </span>
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default CustomMessageInput;
